module.exports = "/assets/_next/static/images/newsletter-complete-760a37cf36713ad400efbddfac23d360.png";